import { useQuery } from "@tanstack/react-query";

import Axios from "@/lib/axios-instance";

// Define the response type
interface GetMySubscriptionResponse {
  meta: {
    error: boolean;
    code: number;
    message: string;
  };
  data: {
    subscription_id: string;
    store_id: string;
    plan_id: number;
    plan_name: string;
    plan_description: string;
    plan_price: number;
    billing_interval: string;
    start_date: string;
    end_date: string;
    days_remaining: number;
    is_active: boolean;
    used_replies: number;
    used_crawl_pages: number;
    used_members: number;
    remaining_subscription_months: number;
    stripe_subscription_id: string;
    created_at: string;
    updated_at: string;
  } | null; // Allow data to be null when no subscription exists
}

export const getMySubscription = async (store_id: string): Promise<GetMySubscriptionResponse> => {
  try {
    const response = await Axios.get(`/customer-subscription/my-subscription?store_id=${store_id}`);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      // Return the error response to handle it properly in the UI
      return error.response.data;
    }
    throw new Error(error.message || "Network Error");
  }
};

export const useGetMySubscription = (store_id: string) => {
  return useQuery({
    queryKey: ["get-my-subscription", store_id],
    queryFn: () => getMySubscription(store_id),
    enabled: !!store_id, // Only run the query if store_id exists
  });
};